import CityPageTemplate from "../city-template/CityPageTemplate";
import { essexConfig } from "./data";

export default function EssexPage() {
  return <CityPageTemplate config={essexConfig} />;
}